import { api } from './axios'

interface CompanyResponse {
  status: string;
  code: number;
  data: {
    companies: Array<{
      id: number;
      name: string;
    }>;
  };
  messages: string[];
}

export const CompanyService = {
  async getCompanies(): Promise<CompanyResponse> {
    try {
      const response = await api.get<CompanyResponse>('/api/back-office/companies')
      return response.data
    } catch (error: any) {
      console.error('Error fetching companies:', error)
      throw new Error(error.response?.data?.messages?.[0] || 'Failed to fetch companies')
    }
  }
}
